"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toToken = void 0;
const tslib_1 = require("tslib");
const bignumber_js_1 = tslib_1.__importDefault(require("bignumber.js"));
const toToken = (value, options) => {
    bignumber_js_1.default.config(Object.assign({ EXPONENTIAL_AT: 29 }, options));
    return new bignumber_js_1.default(value.toString()).multipliedBy(new bignumber_js_1.default(10).pow(18)).toString();
};
exports.toToken = toToken;
//# sourceMappingURL=toToken.js.map